import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';

@Injectable()
export class SocialCreditGroupDialogStore extends ComponentStoreV2Factory {
}
